import APIServiceLookUp from './serviceAPI';
import { API_URL, MAIN_API_URL } from './models/AppConstent';

export default class ServiceMenu {
    lookupService = new APIServiceLookUp();

    async getAllMenus(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}terminal/getAllMenus`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async setMenu(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}menu/setMenu`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async updateMenu(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}menu/updateMenu`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async deleteMenu(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}menu/deleteMenu`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }

    async deleteAll(body) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}menu/deleteAll`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, '');
    }
}